import StoryblokClient from 'storyblok-js-client';
import { StoryblokManagementApiClient } from '../storyblok-management-api';

export const StoryblokClientService = {
  client: new StoryblokClient({
    accessToken: process.env.GATSBY_STORYBLOK_SPACE_API_KEY,
  }),

  managementApiClient: new StoryblokManagementApiClient({
    accessToken: process.env.GATSBY_STORYBLOK_MANAGEMENT_API_KEY,
    spaceId: process.env.GATSBY_STORYBLOK_SPACE_ID,
  }),

  getAllDatasources(): Promise<any[]> {
    const timeStamp = new Date().getTime();

    return this.client.getAll('cdn/datasources', {
      cv: timeStamp,
      per_page: 1000,
    });
  },

  getDefaultDatasourceEntries(): Promise<unknown[]> {
    const timeStamp = new Date().getTime();

    return this.client.getAll('cdn/datasource_entries', {
      cv: timeStamp,
      per_page: 1000,
    });
  },

  getDatasourceEntriesByDimension(dimension: string): Promise<unknown[]> {
    const timeStamp = new Date().getTime();

    return this.client.getAll('cdn/datasource_entries', {
      cv: timeStamp,
      dimension,
      per_page: 1000,
    });
  },

  fetchFundImages(): Promise<unknown> {
    const fundImagesAssetId = process.env.GATSBY_STORYBLOK_ASSETS_ID;
    const fundImagesPath = `assets?per_page=1000&in_folder=${fundImagesAssetId}`;

    return this.managementApiClient.get(fundImagesPath);
  },
};
